import { AxiosResponse } from 'axios';

import { carmaClientLegacy } from 'src/services/instance/carmaClientLegacy';
import { FinanceQuotesResponse } from 'src/types/CataloguePage.types';

import {
  FinanceQuote, // FinanceQuoteConfirmPayload,
  FinanceQuoteRequestPayload,
  FinanceQuoteRequestResponse,
  FinanceQuoteResponse,
} from './FinanceApi.types';

export const getQuoteRequest = (id: string): Promise<FinanceQuoteRequestPayload | null> =>
  carmaClientLegacy
    .get<any, AxiosResponse<FinanceQuoteRequestPayload[]>>(`/me/finance/quote-requests/${id}`)
    .then((body) => (body.data.length ? body.data[0] : null));

export const getQuotes = (id: string): Promise<FinanceQuoteResponse> =>
  carmaClientLegacy
    .get<any, AxiosResponse<FinanceQuoteResponse>>(`/me/finance/quote-requests/${id}/quotes`)
    .then((body) => body.data);

/**
 * Request a quote
 */
export const requestQuote = (payload: FinanceQuoteRequestPayload): Promise<FinanceQuoteRequestResponse> =>
  carmaClientLegacy
    .post<any, AxiosResponse<FinanceQuoteRequestResponse>, FinanceQuoteRequestPayload>(
      `/me/finance/quote-requests`,
      payload,
    )
    .then((body) => body.data);

export const confirmQuote = (quoteRequestId: string, quoteId: string[]): Promise<FinanceQuote[]> =>
  carmaClientLegacy
    .post<any, AxiosResponse<FinanceQuote[]>, string[]>(
      `/me/finance/quote-requests/${quoteRequestId}/quotes/confirm`,
      quoteId,
    )
    .then((body) => body.data);

export const requestPreApprovalCall = async (quoteId: string) => {
  const response = await carmaClientLegacy.post<FinanceQuotesResponse>(
    `/me/finance/quotes/${quoteId}/pre-approval`,
    {},
  );
  return response.data;
};

export const requestYOUxQuote = (quoteRequestId: string) =>
  carmaClientLegacy
    .post<any, any>(`/me/finance/quote-requests/${quoteRequestId}/foreign-resident`)
    .then((body) => body.data);
